module.exports = __webpack_public_path__ + "img/double-arrow-down.a88972ac.svg";